import _ from 'lodash';
import {defaultFields} from './step.fields.utils.js';


//get previous, current, next question
const findQuestions = (schema, answer, parent, state) => {
    state = state || {
        previous: null,
        current: null,
        next: null,
        schema: schema,
    };
    for (let i = 0; i <= schema.length; i++) {
        const node = schema[i];
        if (!node || node.skip_question) continue;
        if (state.current) {
            if (node.required_if) {
                //cast value
                let parent_value = (parent && parent.value) || false;

                if (parent && (parent.value === 'true' || parent.value === 'false')) {
                    parent_value = parent.value === 'true';

                }
                if (node.required_if(parent_value, state.schema)) {
                    state.next = node;
                }
            } else {
                state.next = node;
            }

        } else {
            if (node.key === answer.key) {
                //node found
                state.current = node;
            } else {
                //check if node is required
                if (node.required_if) {
                    //cast value
                    let parent_value = (parent && parent.value) || false;

                    if (parent && (parent.value === 'true' || parent.value === 'false')) {
                        parent_value = parent.value === 'true';
                    }
                    if (node.required_if(parent_value, state.schema)) {

                        state.previous = node;
                    }
                } else {
                    state.previous = node;
                }
            }
            if (node.children) {
                if (node.required_children) {
                    //cast value
                    let node_value = node.value;
                    if (node.value === 'true' || node.value === 'false') {
                        node_value = node.value === 'true';
                    }

                    if (node.required_children(node_value)) {
                        findQuestions(node.children, answer, node, state);
                    }
                } else if (typeof node.children === 'function'){
                    const children = node.children(node.value)
                    findQuestions(children, answer, node, state);
                }
                else {
                    findQuestions(node.children, answer, node, state);
                }
            }
        }

        //exit
        if (state.next || (state.current && i === schema.length - 1)) {
            return state;
        }
    }
};
//get initial schema for a given type
const schemas = {};
const getSchema = (type, data = {}) => {
    try {
        const schema = schemas.hasOwnProperty(type) ? schemas[type] : require(`../schemes/step/schema.step.${type}`).default;
        schemas[type] = schema;
        return populateSchema(schema, data);
    } catch (e) {
        console.error(`Schema ${type} failed to load!`);
        console.error(e);
        return {};
    }
};
//populate questions function
const populateSchema = (schema, data = {}) => {
    for (let i = 0; i < schema.length; i++) {
        // populate default props
        const node = {...(defaultFields.hasOwnProperty(schema[i].key) ? defaultFields[schema[i].key] : {}), ...schema[i]};

        // populate data
        if (data.hasOwnProperty(node.key)) {
            node.value = data[node.key];
        }

        if(typeof node.children === 'function') {
            const children = node.children(node.value)
            populateSchema(children, data);
        }
        // process children
        if (node.children || node.extra_children) {
            populateSchema(node.children || node.extra_children, data);
        }

        //save node to schema
        schema[i] = node;
    }

    return schema;
};
//transform schema to object and update it
const transformSchemaToObject = (schema, data = {}, state = {}) => {
    if (!schema) return {};
    state = state || {
        out: null,
    };
    for (let i = 0; i <= schema.length; i++) {
        const node = schema[i];
        if (!node) continue;
        if (data.hasOwnProperty(node.key)) {
            node.value = data[node.key];
        }
        state.out = {...state.out, ...{[node.key]: node.value}};
        if(typeof node.children === 'function') {
            const children = node.children(node.value)
            transformSchemaToObject(children, data, state);
        }

        if (node.children || node.extra_children) {
            transformSchemaToObject(node.children || node.extra_children, data, state);
        }
    }
    return state.out || {};
};
//remove key _more
const removeExtraDataFromSchema = (schema, state) => {
        state = state || {
            out: {},
        };

        for (let i = 0; i < schema.length; i++) {
            const node = schema[i];
            if (!node) continue;

            //skip on end
            if (node.key === 'end') {
                continue;
            }

            //no more extra with empty values
            if (node.key.endsWith('_more') && !node.value) {
                continue;
            }

            state.out = {...state.out, [node.key]: node.value};

            // has_ with empty value should not include children
            if (node.key.startsWith('has_') && !node.value) {
                continue;
            }
            if (typeof node.children === 'function') {
                const children = node.children(node.value)
                removeExtraDataFromSchema(children, state);
            }
            if (node.children || node.extra_children) {
                removeExtraDataFromSchema(node.children || node.extra_children, state);
            }
        }

        return state.out;
    }
;

//get fields from schema
const getSchemaFields = (schema, keys, state = {}) => {
    state = state || {
        out: [],
    };
    for (let i = 0; i < schema.length; i++) {
        const node = schema[i]
        if (!node) {
            continue
        }
        if (keys.includes(node.key)) {
            state.out = [...state.out ?? [], node]
        }
        if(typeof node.children === 'function') {
            const children = node.children(node.value)
            getSchemaFields(children, keys, state)
        }
        if (node.children) {
            getSchemaFields(node.children, keys, state)
        }
    }
    return state.out ?? []
}

// create progress bar key values
const groupSchemeByPercentageGroup = (schema, state) => {
    state = state || {
        count: 0,
        out: {},
        first_question: '',
    };

    for (let i = 0; i < schema.length; i++) {
        const node = schema[i];
        if (!node || node.skip_question || !node.percentage_group) continue;

        if (!state.first_question) state.first_question = node.key;

        const percentage_group = node.percentage_group;

        if (!state.out[percentage_group]) {
            state.out[percentage_group] = {[node.key]: state.count};
        } else {
            state.out[percentage_group] = {
                ...state.out[percentage_group],
                [node.key]: state.count,
            };
        }
        state.count++;
        if(typeof node.children == 'function') {
            const children = node.children(node.value)
            groupSchemeByPercentageGroup(children, state);
        }
        if (node.children /*|| node.extra_children*/) { //not include extra_children
            groupSchemeByPercentageGroup(node.children/* || node.extra_children*/, state);
        }
    }

    return {scheme: state.out, first_question: state.first_question};
};

const calculateProgressbarSteps = (progressbar_scheme, conf) => {
    let out = _.cloneDeep(progressbar_scheme.scheme);
    _.forEach(out, (v, k) => {
        const total_keys = _.keys(out[k]).length === 0 ? 1 : _.keys(out[k]).length - 1;
        const range = conf[k] ? conf[k] : null;
        if (!range) return;

        const step = Math.ceil(((range.max - range.min) / total_keys) * 100) / 100;
        let acc = range.min;

        // eslint-disable-next-line no-unused-vars
        let index = 0;
        _.forEach(out[k], (_v, _k) => {
            acc = index > 0 ? Math.ceil((acc + step) * 100) / 100 : acc;
            out[k][_k] = acc > 100 ? 100 : acc;
            if (_k === progressbar_scheme.first_question) out[k][_k] = 0;
            index++;
        });
    });
    return out;
};

const progressbarSteps = config => {
    const steps = _.map(config, range => range.min);
    steps.push(100);
    return steps;
};
const progressbarTitles = config => {
    const titles = _.reduce(config, (out, v, k) => {
        out[k] = k;
        return out;
    }, {});
    titles['finish'] = 'Finish';
    return titles;
};

const progressbar = (schema, config) => {
    if (!config || !schema) return {state: {}, steps: [], titles: {}};
    const _schema = groupSchemeByPercentageGroup(schema);

    const state = calculateProgressbarSteps(_schema, config);
    const steps = progressbarSteps(config);
    const titles = progressbarTitles(config);
    return {state, steps, titles};
};

export {
    findQuestions,
    getSchema,
    populateSchema,
    transformSchemaToObject,
    removeExtraDataFromSchema,
    getSchemaFields,
    progressbar
};
